import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Firebase, currentUserRole, isProduction, appConfig } from './../../util';

import { Redirect, withRouter, Link } from 'react-router-dom';
import qs from 'qs';

class ResetPassword extends Component {

  state = {
    password: '',
    formError: null,
    formMessage: null,
    syncingWithServer: false,
    invalidResetCode: false,
    code: null,
    continueUrl: '/login',
    resetComplete: false,
  }

  componentDidMount(){

    this.passwordInput.focus();

    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    let continueUrl = '/login';
    let code = '';

    if(params.oobCode){
      code = params.oobCode;
    }
    if(params.continueUrl){
      continueUrl = params.continueUrl;
    }

    this.setState({
      code,
      continueUrl,
    });

    this.verifyCode(code);
  }

  verifyCode(code){
    Firebase.auth().verifyPasswordResetCode(code).then(() => {

    }).catch(err => {
      this.setState({
        invalidResetCode: true,
        formError: 'Reset password link contains invalid code. Please reset password and try again.'
      });
    })
  }

  submitForm(){
    this.setState({
      syncingWithServer: true,
      formError: false
    });

    Firebase.auth().confirmPasswordReset(this.state.code, this.state.password).then(() => {


      this.setState({
        formMessage: 'Password updated! Redirecting to login page...'
      });

      //redirect after timeout
      setTimeout(() => {
        this.setState({
          resetComplete: true
        });
      }, 3000);
    }).catch(err => {

      this.setState({
        syncingWithServer: false,
        formError: err.message
      });
    });
  }

  getButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Updating...' : 'Update password')
    };
  }

  handleSubmit(event){
    event.preventDefault();
    this.submitForm();
  }

  bodyForm(){

    const { password, syncingWithServer, formError, formMessage, invalidResetCode, email } = this.state;

    if(invalidResetCode){
      return (
        <div className="velocity-form form-group-container page-form">
          <div className="form-message error">{formError}</div>
          <p style={{fontSize: '18px', textAlign: 'center', width: '100%', marginTop: '25px'}}>Click the button below to try again.</p>
            <Link to="/login?forgot=true">
              <button style={{marginTop: '15px', width: '100%'}} className="button primary">Reset Password...</button>
            </Link>
        </div>
      );
    }
    else{
      return (
        <form onSubmit={this.handleSubmit.bind(this)}>
          <div className="velocity-form form-group-container page-form">
            <h2>Create new Password</h2>
            {email &&
              <p>{email}</p>
            }
            {formError &&
              <div className="form-message error">{formError}</div>
            }
            {formMessage &&
              <div className="form-message success">{formMessage}</div>
            }

            <div className="form-group">
              <label htmlFor="velocity-login-password">New Password</label>
              <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer || invalidResetCode} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
            </div>

            <div className="form-group">
              <button className={'button primary' + ((syncingWithServer || invalidResetCode) ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitForm.bind(this)} dangerouslySetInnerHTML={this.getButtonHtml()}></button>
            </div>

          </div>
        </form>
      );
    }
  }

  render() {

    //only redirect after user prop updates in store
    if (this.state.resetComplete) {
      //hard redirect to continue url
      document.location = this.state.continueUrl;
      return null;
      //return <Redirect to={this.state.continueUrl} />
    }

    return (
      <div className="page login">
        {this.bodyForm()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticated: (state.user && state.user.uid) ? true : false
  }
}

export default withRouter(connect(mapStateToProps, {})(ResetPassword));



// WEBPACK FOOTER //
// ./src/components/resetPassword/index.js